import React from 'react';
import { ViewMarketPlace } from '@projectK/modules/FeatureMarketplace';
import Settings from '../../modules/settings';

const UserTypeSettings = React.lazy(() =>
  import('../../modules/admin/UserSettings'),
);
const ServiceSettings = React.lazy(() =>
  import('../../modules/admin/Products/ServiceSettings'),
);
const PackagesSettings = React.lazy(() =>
  import('../../modules/admin/Packages/EditPackages'),
);
const AutoLinks = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks'),
);
const EmailTemplates = React.lazy(() =>
  import('../../modules/admin/EmailTemplates'),
);
const EmailSignatures = React.lazy(() =>
  import('../../modules/admin/EmailSignatures'),
);
const PromoCodeSettings = React.lazy(() =>
  import('../../modules/admin/PromoCodes'),
);
const FeeSettings = React.lazy(() =>
  import('../../modules/admin/ConvenienceFeeSettings'),
);
const GoogleSheetsIntegration = React.lazy(() =>
  import('@projectK/modules/admin/GoogleSheetsIntegration'),
);
const General = React.lazy(() => import('../../modules/admin/General'));
const Location = React.lazy(() => import('../../modules/admin/Location'));
const EmailConfig = React.lazy(() => import('../../modules/admin/EmailConfig'));
const EmailLog = React.lazy(() => import('../../modules/admin/EmailLog'));
const UnsubscribedUsers = React.lazy(() =>
  import('../../modules/admin/UnsubscriedUsers'),
);
const Social = React.lazy(() => import('../../modules/admin/Social'));
const SportsLevel = React.lazy(() =>
  import('../../modules/admin/LevelTypeSettings'),
);
const CalendarSettings = React.lazy(() =>
  import('../../modules/admin/CalendarTypeSettings'),
);
const VerbiageSettings = React.lazy(() =>
  import('../../modules/admin/VerbiageTypeSettings'),
);
const ProductListing = React.lazy(() =>
  import('../../modules/admin/Products/Listing'),
);
const ProductListingPage = React.lazy(() =>
  import('../../modules/admin/Products/ProductListing'),
);
const AddProduct = React.lazy(() =>
  import('../../modules/admin/Products/AddEditProduct'),
);
const Programs = React.lazy(() => import('../../modules/admin/Programs'));
const AddPrograms = React.lazy(() =>
  import('../../modules/admin/Programs/AddProgramsWizard'),
);
const EditPrograms = React.lazy(() =>
  import('../../modules/admin/Programs/EditProgramsWizard'),
);
const EditActivity = React.lazy(() =>
  import(
    '../../modules/admin/Products/ServiceSettings/ActivityInfo/EditActivityWizard'
  ),
);
const ActivitySession = React.lazy(() =>
  import(
    '../../modules/admin/Products/ServiceSettings/ActivityInfo/ActivitySessions'
  ),
);
const Packages = React.lazy(() => import('../../modules/admin/Packages'));
const AddPackages = React.lazy(() =>
  import('../../modules/admin/Packages/AddPackagesWizard'),
);
const Apex = React.lazy(() => import('../../modules/admin/Apex'));

const CreditWallet = React.lazy(() =>
  import('../../modules/admin/CreditSystem/CreditWallets'),
);
const CreditHistory = React.lazy(() =>
  import('../../modules/admin/CreditSystem/CreditsHistory'),
);
const CardDeatils = React.lazy(() =>
  import('../../modules/admin/CreditSystem/ManageCards'),
);
const ManageProfileFieids = React.lazy(() =>
  import('../../modules/admin/ManageProfileFieids'),
);
const Reports = React.lazy(() =>
  import('../../modules/admin/ReportManagement'),
);
const UserReports = React.lazy(() =>
  import('../../modules/admin/ReportManagement/UserReports'),
);
const FacilityLocation = React.lazy(() =>
  import('../../modules/admin/ManageFacilities/Location'),
);
const FacilityAddress = React.lazy(() =>
  import('../../modules/admin/ManageFacilities/Address'),
);
const FacilityResource = React.lazy(() =>
  import('../../modules/admin/ManageFacilities/Resource'),
);
const AttendanceList = React.lazy(() =>
  import('../../modules/admin/AttendanceReport'),
);
const MergedAccountsList = React.lazy(() =>
  import('../../modules/admin/MergedAccounts'),
);
const AllWaiverCombine = React.lazy(() =>
  import('../../modules/admin/AllWaiverCombine'),
);
const ManageActivities = React.lazy(() =>
  import('../../modules/admin/ManageActivities'),
);
const ActivityCalendar = React.lazy(() =>
  import('../../modules/admin/ActivityCalendar'),
);
const ProductDetail = React.lazy(() =>
  import('../../modules/admin/Products/ProductDetail'),
);
const ProgramDetail = React.lazy(() =>
  import('../../modules/student/Programs/ProgramDetail'),
);
const PackageDetail = React.lazy(() =>
  import('../../modules/student/Packages/PackageDetail'),
);
const ManageSessions = React.lazy(() =>
  import('../../modules/admin/ManageSessions'),
);
const OrdersHistroy = React.lazy(() =>
  import('../../modules/admin/AllOrdersHistory'),
);
const PaymentHistroy = React.lazy(() =>
  import('../../modules/admin/AllPaymentsHistory'),
);
const ManageCampus = React.lazy(() =>
  import('../../modules/admin/CampusSettings'),
);
const Users = React.lazy(() => import('../../modules/admin/Users'));
const MissedPayment = React.lazy(() => import('../../modules/admin/MissedPayment'));
const Error403 = React.lazy(() => import('../../modules/errorPages/Error403'));
const AccountPage = React.lazy(() =>
  import('../../modules/student/AccountInfo'),
);
const MyProducts = React.lazy(() =>
  import('../../modules/account/MyProfile/MyProducts'),
);
const UpcommingActivities = React.lazy(() =>
  import('../../modules/account/MyProfile/UpcomingActivities'),
);
const MySchedules = React.lazy(() =>
  import('../../modules/account/MyProfile/UpcomingSchedules'),
);
const ActivityHistory = React.lazy(() =>
  import('../../../../../libs/modules/src/lib/account/MyProfile/ManageHistory'),
);
const ProductWizardPage = React.lazy(() =>
  import('../../modules/ProductWizardPage'),
);
const PackageWidget = React.lazy(() => import('../../modules/PackageWidget'));
const WidgetInfo = React.lazy(() =>
  import('../../modules/admin/Products/ServiceSettings/WidgetInfo'),
);
const PackageWidgetUrl = React.lazy(() =>
  import('../../modules/admin/Packages/EditPackages/PackageWidgetUrl'),
);
const AddToCart = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks/AddToCart'),
);
const AddToCartProduct = React.lazy(() =>
  import('../../modules/admin/Products/ProductLinks/AddToCartProduct'),
);
const CustomReports = React.lazy(() =>
  import('../../modules/admin/CustomReport'),
);
const ProductTypeSettings = React.lazy(() =>
  import('../../modules/admin/ProductTypeSettings'),
);
const Cart = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Carts'),
);
const Checkout = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Checkout'),
);
const OrderConfirmation = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation'),
);

const StripeForm = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation/stripe'),
);
const FailedPayment = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/FailedTranscation'),
);
const TilledCheckout = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Checkout-tilled'),
);
const TransactionHistory = React.lazy(() =>
  import('../../modules/admin/TransactionHistory'),
);
const CommunicationTab = React.lazy(() =>
  import('../../modules/admin/Communication'),
);
const ProfileData = React.lazy(() => import('../../modules/admin/ProfileData'));
const Accounting = React.lazy(() =>
  import('../../modules/admin/Accounting/index'),
);
const ProductPurchaseOptionsBased = React.lazy(() =>
  import('../../modules/admin/Accounting/ProductPurchaseOption'),
);
const PaymentSummary = React.lazy(() =>
  import('../../modules/admin/Accounting/PaymentDetails'),
);
const ManageSubscriptions = React.lazy(() =>
  import('../../modules/admin/ManageSubscriptions'),
);
const TournamentSettings = React.lazy(() =>
  import('../../modules/admin/Tournament/TournamentSettings'),
);
const UnSubscribePage = React.lazy(() =>
  import('../../modules/account/MyProfile/UnSubscribe'),
);
const AllWaitlist = React.lazy(() =>
  import('../../modules/coach/WaitlistUsers'),
);
const TournamentListing = React.lazy(() =>
  import('../../modules/admin/Tournament/Listing'),
);
const TournamentVerbiageSettings = React.lazy(() =>
  import('../../modules/admin/Tournament/TournamentVerbiageSettings'),
);

const Teams = React.lazy(() => import('../../modules/admin/Teams'));
const TeamsEdit = React.lazy(() => import('../../modules/admin/Teams/Edit'));

const AddTournament = React.lazy(() =>
  import('../../modules/admin/Tournament/AddEditTournament'),
);
const ActiveTournaments = React.lazy(() =>
  import('../../modules/admin/Tournament/TournamentsListView'),
);

const EditDivision = React.lazy(() =>
  import(
    '../../modules/admin/Tournament/TournamentSettings/DivisionInfo/EditDivisionWizard'
  ),
);
const OrganizationListing = React.lazy(() =>
  import('../../modules/admin/Organization/Listing'),
);

const FeatureMarket = React.lazy(() =>
  import('../../modules/admin/FeatureMarket'),
);

const AuditLog = React.lazy(() =>
  import('../../modules/admin/AuditLog'),
);

const RolesPermission = React.lazy(() =>
  import('../../modules/admin/RolesAndPermissions'),
);

const Dashboard = React.lazy(() =>
  import('../../modules/admin/Dashboard'),
);

export const adminPagesConfigs = [
  {
    path: '/payment-details',
    element: <PaymentHistroy />,
  },
  {
    path: '/admin/profile-data',
    element: <ProfileData />,
  },
  {
    path: '/product-details/:productId',
    element: <ProductDetail />,
  },
  {
    path: '/admin/products',
    element: <ProductListingPage />,
  },

  {
    path: '/admin/program-details/:programId',
    element: <ProgramDetail />,
  },
  {
    path: '/package-details/:packageId',
    element: <PackageDetail />,
  },
  {
    path: '/admin/settings/emailtemplates',
    element: <EmailTemplates />,
  },
  {
    path: '/admin/settings/email-signatures',
    element: <EmailSignatures />,
  },
  {
    path: '/admin/settings/verbiage',
    element: <VerbiageSettings />,
  },
  {
    path: '/admin/settings/calendar',
    element: <CalendarSettings />,
  },
  {
    path: '/admin/settings/social',
    element: <Social />,
  },
  {
    path: '/admin/settings/general',
    element: <General />,
  },
  {
    path: '/admin/settings/location',
    element: <Location />,
  },
  {
    path: '/admin/settings/email-config',
    element: <EmailConfig />,
  },

  {
    path: '/admin/settings/email-log',
    element: <EmailLog />,
  },
  {
    path: '/admin/settings/unsubscribed-users',
    element: <UnsubscribedUsers />,
  },
  {
    path: '/admin/settings/apex',
    element: <Apex />,
  },
  {
    path: '/admin/settings/sportlevels',
    element: <SportsLevel />,
  },
  {
    path: '/admin/settings/conveniencefee',
    element: <FeeSettings />,
  },
  {
    path: '/admin/settings/usertype',
    element: <UserTypeSettings />,
  },
  {
    path: '/admin/settings/promocodes',
    element: <PromoCodeSettings />,
  },
  {
    path: '/admin/product-listing',
    element: <ProductListing />,
  },
  {
    path: '/admin/add-products',
    element: <AddProduct />,
  },
  {
    path: '/admin/programs',
    element: <Programs />,
  },
  {
    path: '/admin/add-programs',
    element: <AddPrograms />,
  },
  {
    path: '/admin/edit-programs/:id',
    element: <EditPrograms />,
  },
  {
    path: '/admin/edit-activity/:productId/:activityId',
    element: <EditActivity />,
  },
  {
    path: '/admin/edit-session/:productId/:sessionId',
    element: <ActivitySession />,
  },
  {
    path: '/admin/users',
    element: <Users />,
  },

  {
    path: '/admin/service/settings/:id',
    element: <ServiceSettings />,
  },
  {
    path: '/admin/error-pages/error-403',
    element: <Error403 />,
  },
  {
    path: '/admin/packages',
    element: <Packages />,
  },
  {
    path: '/admin/credit-wallets',
    element: <CreditWallet />,
  },
  {
    path: '/admin/credit-history',
    element: <CreditHistory />,
  },
  {
    path: '/admin/card-details',
    element: <CardDeatils />,
  },
  {
    path: '/admin/reports',
    element: <Reports />,
  },
  {
    path: '/admin/addpackages',
    element: <AddPackages />,
  },
  {
    path: '/admin/apps/package/settings/:id',
    element: <PackagesSettings />,
  },
  {
    path: '/admin/user-reports',
    element: <UserReports />,
  },
  {
    path: '/admin/address',
    element: <FacilityAddress />,
  },
  {
    path: '/admin/location',
    element: <FacilityLocation />,
  },
  {
    path: '/admin/resource',
    element: <FacilityResource />,
  },
  {
    path: '/admin/attendance',
    element: <AttendanceList />,
  },
  {
    path: '/admin/merged-accounts',
    element: <MergedAccountsList />,
  },
  {
    path: '/admin/settings/waiversettings',
    element: <AllWaiverCombine />,
  },
  {
    path: '/admin/activities',
    element: <ManageActivities />,
  },
  {
    path: '/calendar',
    element: <ActivityCalendar />,
  },
  {
    path: '/admin/activity-session',
    element: <ManageSessions />,
  },

  {
    path: '/admin/my-account',
    element: <AccountPage />,
  },
  {
    path: '/admin/my-products',
    element: <MyProducts />,
  },
  {
    path: '/admin/upcoming-activities',
    element: <UpcommingActivities />,
  },
  {
    path: '/admin/my-schedules',
    element: <MySchedules />,
  },
  {
    path: '/admin/my-waitlist',
    element: <AllWaitlist />,
  },
  {
    path: '/admin/activity-history',
    element: <ActivityHistory />,
  },
  {
    path: '/admin/manage-orders',
    element: <OrdersHistroy />,
  },
  {
    element: <WidgetInfo />,
  },
  {
    element: <PackageWidgetUrl />,
  },
  {
    path: '/widgets/products/:productSlug',
    element: <ProductWizardPage isProduct={true} />,
  },
  {
    path: '/widgets/packages/:packageSlug',
    element: <PackageWidget />,
  },
  {
    path: '/purchasePackage/:purchaseId/:packageId',
    element: <AutoLinks />,
  },
  {
    path: '/purchasePackage/addtocart/:purchaseId/:packageId',
    element: <AddToCart />,
  },
  {
    path: '/product/addtocart/:purchaseId/:productId',
    element: <AddToCartProduct />,
  },
  {
    path: '/campus-settings',
    element: <ManageCampus />,
  },
  {
    path: '/admin/product-type-settings',
    element: <ProductTypeSettings />,
  },
  {
    path: '/admin/custom-report',
    element: <CustomReports />,
  },
  {
    path: '/order/confirmation/:transId',
    element: <OrderConfirmation />,
  },
  {
    path: '/stripe',
    element: <StripeForm />,
  },
  {
    path: '/order/failed/:transId',
    element: <FailedPayment />,
  },
  {
    path: '/cart',
    element: <Cart />,
  },
  {
    path: '/checkout',
    element: <Checkout />,
  },
  {
    path: '/checkout-tilled',
    element: <TilledCheckout />,
  },
  {
    path: '/transaction-history',
    element: <TransactionHistory />,
  },
  {
    path: '/admin/communication',
    element: <CommunicationTab />,
  },
  {
    path: '/accounting',
    element: <Accounting />,
  },
  {
    path: '/purchase-option',
    element: <ProductPurchaseOptionsBased />,
  },
  {
    path: '/payment-summary',
    element: <PaymentSummary />,
  },
  {
    path: '/order-details',
    element: <OrdersHistroy />,
  },
  {
    path: '/subscriptions',
    element: <ManageSubscriptions />,
  },
  {
    path: '/missed-payments',
    element: <MissedPayment />,
  },
  {
    path: '/admin/manage-profileFieids',
    element: <ManageProfileFieids />,
  },
  {
    path: '/user/unsubscribe',
    element: <UnSubscribePage />,
  },
  {
    path: '/admin/tournament-listing',
    element: <TournamentListing />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/admin/teams',
    element: <Teams />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/admin/teams/:id',
    element: <TeamsEdit />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/tournaments',
    element: <ActiveTournaments />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/admin/add-tournaments',
    element: <AddTournament />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/admin/tournament/settings/:id',
    element: <TournamentSettings />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/admin/edit-division/:tournamentId/:divisionId',
    element: <EditDivision />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/widgets/tournament/:tournamentSlug',
    element: <ProductWizardPage isProduct={false} />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/admin/organization-listing',
    element: <OrganizationListing />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/admin/featuremarket',
    element: <FeatureMarket />,
  },
  {
    path: '/admin/featuremarket/viewmarket/:slug',
    element: <ViewMarketPlace />,
  },
  {
    path: '/admin/audit-log',
    element: <AuditLog />,
  },
  {
    path: '/admin/roles-permission',
    element: <RolesPermission />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/settings',
    element: <Settings />,
  },
  {
    path: '/admin/tournament-google-sheets/*',
    element: <GoogleSheetsIntegration />,
    requiresTournamentAddon: true,
  },
  {
    path: '/admin/tournament-settings',
    element: <TournamentVerbiageSettings />,
    requiresTournamentAddon: true, // Add this flag
  },
];
